<template>
  <div class="px-4 pb-5 text-gray-500">
    <div v-if="disabled" class="break-words">
      {{ description }}
    </div>
    <ResizingTextArea
      v-else
      v-model="inputText"
      class="-mb-3 w-full overflow-y-hidden rounded-md text-sm text-gray-700"
      :placeholder="$t('ACTIVITY.TASK.TASK_DESCRIPTION')"
      :name="name"
      @update:model-value="$emit('update', $event)"
      @blur="$emit('submit')"
    />
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from "vue";

import ResizingTextArea from "@/views/deals/components/dealNotes/AutoresizingTextArea.vue";

defineEmits<{ update: [string]; submit: [] }>();

const props = defineProps({
  description: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "description",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const inputText = ref(props.description);

watch([() => props.description, () => props.disabled], () => {
  inputText.value = props.description;
});
</script>
